<template>
  <a-card>
    <div class="personnel">
      <a-tabs default-active-key="1">
        <a-tab-pane key="1" tab="从业人员公示">
          <employment></employment>
        </a-tab-pane>
        <a-tab-pane key="2" tab="债券交易人员">
          <bondPersonnel></bondPersonnel>
        </a-tab-pane>
      </a-tabs>
    </div>
  </a-card>
</template>

<script>
import employment from './employment.vue';
import bondPersonnel from './bondPersonnel.vue';
export default {
  data() {
    return {
      loading: false
    };
  },
  components: { employment, bondPersonnel },
  created() {},
  methods: {}
};
</script>

<style lang="less">
.personnel {
}
</style>
